export const clonePrices = [
  {
    resource: 'compute_cores',
    group: 'ru-1a',
    name: {
      ru: 'Процессорные ядра (VCPU), 1 ядро Intel® Xeon® E5-2670v3',
      en: 'Processors (vCPU), 1 vCPU Intel® Xeon® E5-2670v3'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'compute_cores',
    group: 'ru-1b',
    name: {
      ru: 'Процессорные ядра (VCPU), 1 ядро Intel® Xeon® E5-2680v4',
      en: 'Processors (vCPU), 1 vCPU Intel® Xeon® E5-2680v4'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'compute_cores',
    group: 'ru-1c',
    name: {
      ru: 'Процессорные ядра (VCPU), 1 ядро Intel® Xeon® Gold 5218',
      en: 'Processors (vCPU), 1 vCPU Intel® Xeon® Gold 5218'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'compute_cores',
    group: 'ru-2a',
    name: {
      ru: 'Процессорные ядра (VCPU), 1 ядро Intel® Xeon® E5-2670v3',
      en: 'Processors (vCPU), 1 vCPU Intel® Xeon® E5-2670v3'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'compute_cores',
    group: 'ru-2b',
    name: {
      ru: 'Процессорные ядра (VCPU), 1 ядро Intel® Xeon® Gold 6140',
      en: 'Processors (vCPU), 1 vCPU Intel® Xeon® Gold 6140'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'compute_cores',
    group: 'ru-2c',
    name: {
      ru: 'Процессорные ядра (VCPU), 1 ядро Intel® Xeon® Gold 6240R',
      en: 'Processors (vCPU), 1 vCPU Intel® Xeon® Gold 6240R'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'compute_cores',
    group: 'ru-3a',
    name: {
      ru: 'Процессорные ядра (VCPU), 1 ядро Intel® Xeon® Gold 6140',
      en: 'Processors (vCPU), 1 vCPU Intel® Xeon® Gold 6140'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'compute_cores',
    group: 'ru-3b',
    name: {
      ru: 'Процессорные ядра (VCPU), 1 ядро Intel® Xeon® Gold 6140',
      en: 'Processors (vCPU), 1 vCPU Intel® Xeon® Gold 6140'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'compute_cores',
    group: 'ru-7a',
    name: {
      ru: 'Процессорные ядра (VCPU), 1 ядро Intel® Xeon® Gold 6240R',
      en: 'Processors (vCPU), 1 vCPU Intel® Xeon® Gold 6240R'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'compute_cores',
    group: 'ru-8a',
    name: {
      ru: 'Процессорные ядра (VCPU), 1 ядро Intel® Xeon® Gold 6240R',
      en: 'Processors (vCPU), 1 vCPU Intel® Xeon® Gold 6240R'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'compute_cores',
    group: 'ru-9a',
    name: {
      ru: 'Процессорные ядра (VCPU), 1 ядро Intel® Xeon® Gold 6240R',
      en: 'Processors (vCPU), 1 vCPU Intel® Xeon® Gold 6240R'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'compute_pci_gpu_gtx1080',
    group: 'ru-1a',
    name: {
      ru: 'Графическая карта (GPU), GTX 1080',
      en: 'Graphics Processing Unit, NVidia® GTX 1080'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'compute_pci_gpu_gtx1080',
    group: 'ru-1b',
    name: {
      ru: 'Графическая карта (GPU), GTX 1080',
      en: 'Graphics Processing Unit, GTX 1080'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'compute_pci_gpu_gtx1080',
    group: 'ru-1c',
    name: {
      ru: 'Графическая карта (GPU), GTX 1080',
      en: 'Graphics Processing Unit, GTX 1080'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'compute_pci_gpu_gtx1080',
    group: 'ru-2b',
    name: {
      ru: 'Графическая карта (GPU), GTX 1080',
      en: 'Graphics Processing Unit, GTX 1080'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'compute_pci_gpu_gtx1080',
    group: 'ru-3a',
    name: {
      ru: 'Графическая карта (GPU), GTX 1080',
      en: 'Graphics Processing Unit, GTX 1080'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'compute_pci_gpu_gtx1080',
    group: 'ru-7a',
    name: {
      ru: 'Графическая карта (GPU), GTX 1080',
      en: 'Graphics Processing Unit, GTX 1080'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'compute_pci_gpu_gtx1080',
    group: 'ru-9a',
    name: {
      ru: 'Графическая карта (GPU), GTX 1080',
      en: 'Graphics Processing Unit, GTX 1080'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'compute_pci_gpu_t4',
    group: 'ru-9a',
    name: {
      ru: 'Графическая карта(GPU), Tesla T4',
      en: 'Graphics Processing Unit, Tesla T4'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'compute_ram',
    group: 'ru-1a',
    name: {
      ru: 'Оперативная память (RAM), 1 ГБ',
      en: 'RAM, 1 GB'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'compute_ram',
    group: 'ru-1b',
    name: {
      ru: 'Оперативная память (RAM), 1 ГБ',
      en: 'RAM, 1 GB'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'compute_ram',
    group: 'ru-1c',
    name: {
      ru: 'Оперативная память (RAM), 1 ГБ',
      en: 'RAM, 1 GB'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'compute_ram',
    group: 'ru-2a',
    name: {
      ru: 'Оперативная память (RAM), 1 ГБ',
      en: 'RAM, 1 GB'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'compute_ram',
    group: 'ru-2b',
    name: {
      ru: 'Оперативная память (RAM), 1 ГБ',
      en: 'RAM, 1 GB'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'compute_ram',
    group: 'ru-2c',
    name: {
      ru: 'Оперативная память (RAM), 1 ГБ',
      en: 'RAM, 1 GB'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'compute_ram',
    group: 'ru-3a',
    name: {
      ru: 'Оперативная память (RAM), 1 ГБ',
      en: 'RAM, 1 GB'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'compute_ram',
    group: 'ru-3b',
    name: {
      ru: 'Оперативная память (RAM), 1 ГБ',
      en: 'RAM, 1 GB'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'compute_ram',
    group: 'ru-7a',
    name: {
      ru: 'Оперативная память (RAM), 1 ГБ',
      en: 'RAM, 1 GB'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'compute_ram',
    group: 'ru-8a',
    name: {
      ru: 'Оперативная память (RAM), 1 ГБ',
      en: 'RAM, 1 GB'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'compute_ram',
    group: 'ru-9a',
    name: {
      ru: 'Оперативная память (RAM), 1 ГБ',
      en: 'RAM, 1 GB'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'exttraffic',
    group: 'ru-1',
    name: {
      ru: 'Превышение лимита, 1 ГБ*',
      en: 'Additional traffic, 1 GB*'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'exttraffic',
    group: 'ru-2',
    name: {
      ru: 'Превышение лимита, 1 ГБ*',
      en: 'Additional traffic, 1 GB*'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'exttraffic',
    group: 'ru-3',
    name: {
      ru: 'Превышение лимита, 1 ГБ*',
      en: 'Additional traffic, 1 GB*'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'exttraffic',
    group: 'ru-7',
    name: {
      ru: 'Превышение лимита, 1 ГБ*',
      en: 'Additional traffic, 1 GB*'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'exttraffic',
    group: 'ru-8',
    name: {
      ru: 'Превышение лимита, 1 ГБ*',
      en: 'Additional traffic, 1 GB*'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'exttraffic',
    group: 'ru-9',
    name: {
      ru: 'Превышение лимита, 1 ГБ*',
      en: 'Additional traffic, 1 GB*'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'image_gigabytes',
    group: 'ru-1',
    name: {
      ru: 'Хранение пользовательских образов, 1 ГБ',
      en: 'Image storage, 1 GB'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'image_gigabytes',
    group: 'ru-2',
    name: {
      ru: 'Хранение пользовательских образов, 1 ГБ',
      en: 'Image storage, 1 GB'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'image_gigabytes',
    group: 'ru-3',
    name: {
      ru: 'Хранение пользовательских образов, 1 ГБ',
      en: 'Image storage, 1 GB'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'image_gigabytes',
    group: 'ru-7',
    name: {
      ru: 'Хранение пользовательских образов, 1 ГБ',
      en: 'Image storage, 1 GB'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'image_gigabytes',
    group: 'ru-8',
    name: {
      ru: 'Хранение пользовательских образов, 1 ГБ',
      en: 'Image storage, 1 GB'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'image_gigabytes',
    group: 'ru-9',
    name: {
      ru: 'Хранение пользовательских образов, 1 ГБ',
      en: 'Image storage, 1 GB'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'license_windows_2012_standard',
    group: 'ru-1',
    name: {
      ru: 'Лицензия Microsoft Windows Server Standard Edition 2012 R2, 1 шт.',
      en: 'Microsoft Windows Server Standard Edition 2012 R2 license, 1 license'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'license_windows_2012_standard',
    group: 'ru-2',
    name: {
      ru: 'Лицензия Microsoft Windows Server Standard Edition 2012 R2, 1 шт.',
      en: 'Microsoft Windows Server Standard Edition 2012 R2 license, 1 license'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'license_windows_2012_standard',
    group: 'ru-3',
    name: {
      ru: 'Лицензия Microsoft Windows Server Standard Edition 2012 R2, 1 шт.',
      en: 'Microsoft Windows Server Standard Edition 2012 R2 license, 1 license'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'license_windows_2012_standard',
    group: 'ru-7',
    name: {
      ru: 'Лицензия Microsoft Windows Server Standard Edition 2012 R2, 1 шт.',
      en: 'Microsoft Windows Server Standard Edition 2012 R2 license, 1 license'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'license_windows_2012_standard',
    group: 'ru-8',
    name: {
      ru: 'Лицензия Microsoft Windows Server Standard Edition 2012 R2, 1 шт.',
      en: 'Microsoft Windows Server Standard Edition 2012 R2 license, 1 license'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'license_windows_2012_standard',
    group: 'ru-9',
    name: {
      ru: 'Лицензия Microsoft Windows Server Standard Edition 2012 R2, 1 шт.',
      en: 'Microsoft Windows Server Standard Edition 2012 R2 license, 1 license'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'license_windows_2016_standard',
    group: 'ru-1',
    name: {
      ru: 'Лицензия Microsoft Windows Server 2016 Standard Edition, 1 шт.',
      en: 'Microsoft Windows Server 2016 Standard Edition license, 1 license'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'license_windows_2016_standard',
    group: 'ru-2',
    name: {
      ru: 'Лицензия Microsoft Windows Server 2016 Standard Edition, 1 шт.',
      en: 'Microsoft Windows Server 2016 Standard Edition license, 1 license'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'license_windows_2016_standard',
    group: 'ru-3',
    name: {
      ru: 'Лицензия Microsoft Windows Server 2016 Standard Edition, 1 шт.',
      en: 'Microsoft Windows Server 2016 Standard Edition license, 1 license'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'license_windows_2016_standard',
    group: 'ru-7',
    name: {
      ru: 'Лицензия Microsoft Windows Server 2016 Standard Edition, 1 шт.',
      en: 'Microsoft Windows Server 2016 Standard Edition license, 1 license'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'license_windows_2016_standard',
    group: 'ru-8',
    name: {
      ru: 'Лицензия Microsoft Windows Server 2016 Standard Edition, 1 шт.',
      en: 'Microsoft Windows Server 2016 Standard Edition license, 1 license'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'license_windows_2016_standard',
    group: 'ru-9',
    name: {
      ru: 'Лицензия Microsoft Windows Server 2016 Standard Edition, 1 шт.',
      en: 'Microsoft Windows Server 2016 Standard Edition license, 1 license'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'license_windows_2019_standard',
    group: 'ru-1',
    name: {
      ru: 'Лицензия Microsoft Windows Server 2019 R2 Standard, 1 шт.',
      en: 'Microsoft Windows Server Standard Edition 2019 R2 license, 1 license'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'license_windows_2019_standard',
    group: 'ru-2',
    name: {
      ru: 'Лицензия Microsoft Windows Server 2019 R2 Standard, 1 шт.',
      en: 'Microsoft Windows Server Standard Edition 2019 R2 license, 1 license'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'license_windows_2019_standard',
    group: 'ru-3',
    name: {
      ru: 'Лицензия Microsoft Windows Server 2019 R2 Standard, 1 шт.',
      en: 'Microsoft Windows Server Standard Edition 2019 R2 license, 1 license'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'license_windows_2019_standard',
    group: 'ru-7',
    name: {
      ru: 'Лицензия Microsoft Windows Server 2019 R2 Standard, 1 шт.',
      en: 'Microsoft Windows Server Standard Edition 2019 R2 license, 1 license'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'license_windows_2019_standard',
    group: 'ru-8',
    name: {
      ru: 'Лицензия Microsoft Windows Server 2019 R2 Standard, 1 шт.',
      en: 'Microsoft Windows Server Standard Edition 2019 R2 license, 1 license'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'license_windows_2019_standard',
    group: 'ru-9',
    name: {
      ru: 'Лицензия Microsoft Windows Server 2019 R2 Standard, 1 шт.',
      en: 'Microsoft Windows Server Standard Edition 2019 R2 license, 1 license'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'load_balancers',
    group: 'ru-1',
    name: {
      ru: 'Балансировщик нагрузки',
      en: 'Load Balancer'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'load_balancers',
    group: 'ru-2',
    name: {
      ru: 'Балансировщик нагрузки',
      en: 'Load Balancer'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'load_balancers',
    group: 'ru-3',
    name: {
      ru: 'Балансировщик нагрузки',
      en: 'Load Balancer'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'load_balancers',
    group: 'ru-7',
    name: {
      ru: 'Балансировщик нагрузки',
      en: 'Load Balancer'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'load_balancers',
    group: 'ru-8',
    name: {
      ru: 'Балансировщик нагрузки',
      en: 'Load Balancer'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'load_balancers',
    group: 'ru-9',
    name: {
      ru: 'Балансировщик нагрузки',
      en: 'Load Balancer'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'network_floatingips',
    group: 'ru-1',
    name: {
      ru: 'Плавающий IP-адрес',
      en: 'Floating IP address'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'network_floatingips',
    group: 'ru-2',
    name: {
      ru: 'Плавающий IP-адрес',
      en: 'Floating IP address'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'network_floatingips',
    group: 'ru-3',
    name: {
      ru: 'Плавающий IP-адрес',
      en: 'Floating IP address'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'network_floatingips',
    group: 'ru-7',
    name: {
      ru: 'Плавающий IP-адрес',
      en: 'Floating IP address'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'network_floatingips',
    group: 'ru-8',
    name: {
      ru: 'Плавающий IP-адрес',
      en: 'Floating IP address'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'network_floatingips',
    group: 'ru-9',
    name: {
      ru: 'Плавающий IP-адрес',
      en: 'Floating IP address'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'network_subnets_24',
    group: 'ru-1',
    name: {
      ru: 'Публичная подсеть из 253 IP-адресов',
      en: 'Public subnet with 253 IP addresses'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'network_subnets_24',
    group: 'ru-2',
    name: {
      ru: 'Публичная подсеть из 253 IP-адресов',
      en: 'Public subnet with 253 IP addresses'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'network_subnets_24',
    group: 'ru-3',
    name: {
      ru: 'Публичная подсеть из 253 IP-адресов',
      en: 'Public subnet with 253 IP addresses'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'network_subnets_24',
    group: 'ru-7',
    name: {
      ru: 'Публичная подсеть из 253 IP-адресов',
      en: 'Public subnet with 253 IP addresses'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'network_subnets_24',
    group: 'ru-8',
    name: {
      ru: 'Публичная подсеть из 253 IP-адресов',
      en: 'Public subnet with 253 IP addresses'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'network_subnets_24',
    group: 'ru-9',
    name: {
      ru: 'Публичная подсеть из 253 IP-адресов',
      en: 'Public subnet with 253 IP addresses'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'network_subnets_25',
    group: 'ru-1',
    name: {
      ru: 'Публичная подсеть из 125 IP-адресов',
      en: 'Public subnet with 125 IP addresses'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'network_subnets_25',
    group: 'ru-2',
    name: {
      ru: 'Публичная подсеть из 125 IP-адресов',
      en: 'Public subnet with 125 IP addresses'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'network_subnets_25',
    group: 'ru-3',
    name: {
      ru: 'Публичная подсеть из 125 IP-адресов',
      en: 'Public subnet with 125 IP addresses'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'network_subnets_25',
    group: 'ru-7',
    name: {
      ru: 'Публичная подсеть из 125 IP-адресов',
      en: 'Public subnet with 125 IP addresses'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'network_subnets_25',
    group: 'ru-8',
    name: {
      ru: 'Публичная подсеть из 125 IP-адресов',
      en: 'Public subnet with 125 IP addresses'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'network_subnets_25',
    group: 'ru-9',
    name: {
      ru: 'Публичная подсеть из 125 IP-адресов',
      en: 'Public subnet with 125 IP addresses'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'network_subnets_26',
    group: 'ru-1',
    name: {
      ru: 'Публичная подсеть из 61 IP-адресов',
      en: 'Public subnet with 61 IP addresses'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'network_subnets_26',
    group: 'ru-2',
    name: {
      ru: 'Публичная подсеть из 61 IP-адресов',
      en: 'Public subnet with 61 IP addresses'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'network_subnets_26',
    group: 'ru-3',
    name: {
      ru: 'Публичная подсеть из 61 IP-адресов',
      en: 'Public subnet with 61 IP addresses'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'network_subnets_26',
    group: 'ru-7',
    name: {
      ru: 'Публичная подсеть из 61 IP-адресов',
      en: 'Public subnet with 61 IP addresses'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'network_subnets_26',
    group: 'ru-8',
    name: {
      ru: 'Публичная подсеть из 61 IP-адресов',
      en: 'Public subnet with 61 IP addresses'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'network_subnets_26',
    group: 'ru-9',
    name: {
      ru: 'Публичная подсеть из 61 IP-адресов',
      en: 'Public subnet with 61 IP addresses'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'network_subnets_27',
    group: 'ru-1',
    name: {
      ru: 'Публичная подсеть из 29 IP-адресов',
      en: 'Public subnet with 29 IP addresses'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'network_subnets_27',
    group: 'ru-2',
    name: {
      ru: 'Публичная подсеть из 29 IP-адресов',
      en: 'Public subnet with 29 IP addresses'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'network_subnets_27',
    group: 'ru-3',
    name: {
      ru: 'Публичная подсеть из 29 IP-адресов',
      en: 'Public subnet with 29 IP addresses'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'network_subnets_27',
    group: 'ru-7',
    name: {
      ru: 'Публичная подсеть из 29 IP-адресов',
      en: 'Public subnet with 29 IP addresses'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'network_subnets_27',
    group: 'ru-8',
    name: {
      ru: 'Публичная подсеть из 29 IP-адресов',
      en: 'Public subnet with 29 IP addresses'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'network_subnets_27',
    group: 'ru-9',
    name: {
      ru: 'Публичная подсеть из 29 IP-адресов',
      en: 'Public subnet with 29 IP addresses'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'network_subnets_28',
    group: 'ru-1',
    name: {
      ru: 'Публичная подсеть из 13 IP-адресов',
      en: 'Public subnet with 13 IP addresses'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'network_subnets_28',
    group: 'ru-2',
    name: {
      ru: 'Публичная подсеть из 13 IP-адресов',
      en: 'Public subnet with 13 IP addresses'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'network_subnets_28',
    group: 'ru-3',
    name: {
      ru: 'Публичная подсеть из 13 IP-адресов',
      en: 'Public subnet with 13 IP addresses'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'network_subnets_28',
    group: 'ru-7',
    name: {
      ru: 'Публичная подсеть из 13 IP-адресов',
      en: 'Public subnet with 13 IP addresses'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'network_subnets_28',
    group: 'ru-8',
    name: {
      ru: 'Публичная подсеть из 13 IP-адресов',
      en: 'Public subnet with 13 IP addresses'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'network_subnets_28',
    group: 'ru-9',
    name: {
      ru: 'Публичная подсеть из 13 IP-адресов',
      en: 'Public subnet with 13 IP addresses'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'network_subnets_29',
    group: 'ru-1',
    name: {
      ru: 'Публичная подсеть из 5 IP-адресов',
      en: 'Public subnet with 5 IP addresses'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'network_subnets_29',
    group: 'ru-2',
    name: {
      ru: 'Публичная подсеть из 5 IP-адресов',
      en: 'Public subnet with 5 IP addresses'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'network_subnets_29',
    group: 'ru-3',
    name: {
      ru: 'Публичная подсеть из 5 IP-адресов',
      en: 'Public subnet with 5 IP addresses'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'network_subnets_29',
    group: 'ru-7',
    name: {
      ru: 'Публичная подсеть из 5 IP-адресов',
      en: 'Public subnet with 5 IP addresses'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'network_subnets_29',
    group: 'ru-8',
    name: {
      ru: 'Публичная подсеть из 5 IP-адресов',
      en: 'Public subnet with 5 IP addresses'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'network_subnets_29',
    group: 'ru-9',
    name: {
      ru: 'Публичная подсеть из 5 IP-адресов',
      en: 'Public subnet with 5 IP addresses'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'network_subnets_29_vrrp',
    group: '',
    name: {
      ru: '',
      en: ''
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'new_exttraffic',
    group: 'ru-1',
    name: {
      ru: '',
      en: ''
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'new_exttraffic',
    group: 'ru-2',
    name: {
      ru: '',
      en: ''
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'new_exttraffic',
    group: 'ru-3',
    name: {
      ru: '',
      en: ''
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'new_exttraffic',
    group: 'ru-7',
    name: {
      ru: '',
      en: ''
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'new_exttraffic',
    group: 'ru-8',
    name: {
      ru: '',
      en: ''
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'volume_gigabytes_basic',
    group: 'ru-1a',
    name: {
      ru: 'Базовый диск, 1 ГБ',
      en: 'Basic disk, 1 GB'
    },
    type: {
      en: 'Enterprise SATA',
      ru: 'SATA enterprise-класса'
    },
    throughput: {
      en: '100 MiB/s',
      ru: '100 МиБ/сек.'
    },
    write: '120 IOPS',
    read: '320 IOPS'
  },
  {
    resource: 'volume_gigabytes_basic',
    group: 'ru-1b',
    name: {
      ru: 'Базовый диск, 1 ГБ',
      en: 'Basic disk, 1 GB'
    },
    type: null,
    throughput: {
      en: '100 MiB/s',
      ru: '100 МиБ/сек.'
    },
    write: '120 IOPS',
    read: '320 IOPS'
  },
  {
    resource: 'volume_gigabytes_basic',
    group: 'ru-1c',
    name: {
      ru: 'Базовый диск, 1 ГБ',
      en: 'Basic disk, 1 GB'
    },
    type: null,
    throughput: {
      en: '100 MiB/s',
      ru: '100 МиБ/сек.'
    },
    write: '120 IOPS',
    read: '320 IOPS'
  },
  {
    resource: 'volume_gigabytes_basic',
    group: 'ru-2a',
    name: {
      ru: 'Базовый диск, 1 ГБ',
      en: 'Basic disk, 1 GB'
    },
    type: null,
    throughput: {
      en: '100 MiB/s',
      ru: '100 МиБ/сек.'
    },
    write: '120 IOPS',
    read: '320 IOPS'
  },
  {
    resource: 'volume_gigabytes_basic',
    group: 'ru-2b',
    name: {
      ru: 'Базовый диск, 1 ГБ',
      en: 'Basic disk, 1 GB'
    },
    type: null,
    throughput: {
      en: '100 MiB/s',
      ru: '100 МиБ/сек.'
    },
    write: '120 IOPS',
    read: '320 IOPS'
  },
  {
    resource: 'volume_gigabytes_basic',
    group: 'ru-2c',
    name: {
      ru: 'Базовый диск, 1 ГБ',
      en: 'Basic disk, 1 GB'
    },
    type: null,
    throughput: {
      en: '100 MiB/s',
      ru: '100 МиБ/сек.'
    },
    write: '120 IOPS',
    read: '320 IOPS'
  },
  {
    resource: 'volume_gigabytes_basic',
    group: 'ru-3a',
    name: {
      ru: 'Базовый диск, 1 ГБ',
      en: 'Basic disk, 1 GB'
    },
    type: null,
    throughput: {
      en: '100 MiB/s',
      ru: '100 МиБ/сек.'
    },
    write: '120 IOPS',
    read: '320 IOPS'
  },
  {
    resource: 'volume_gigabytes_basic',
    group: 'ru-3b',
    name: {
      ru: 'Базовый диск, 1 ГБ',
      en: 'Basic disk, 1 GB'
    },
    type: null,
    throughput: {
      en: '100 MiB/s',
      ru: '100 МиБ/сек.'
    },
    write: '120 IOPS',
    read: '320 IOPS'
  },
  {
    resource: 'volume_gigabytes_basic',
    group: 'ru-7a',
    name: {
      ru: 'Базовый диск, 1 ГБ',
      en: 'Basic disk, 1 GB'
    },
    type: null,
    throughput: {
      en: '100 MiB/s',
      ru: '100 МиБ/сек.'
    },
    write: '120 IOPS',
    read: '320 IOPS'
  },
  {
    resource: 'volume_gigabytes_basic',
    group: 'ru-8a',
    name: {
      ru: 'Базовый диск, 1 ГБ',
      en: 'Basic disk, 1 GB'
    },
    type: null,
    throughput: {
      en: '100 MiB/s',
      ru: '100 МиБ/сек.'
    },
    write: '120 IOPS',
    read: '320 IOPS'
  },
  {
    resource: 'volume_gigabytes_basic',
    group: 'ru-9a',
    name: {
      ru: 'Базовый диск, 1 ГБ',
      en: 'Basic disk, 1 GB'
    },
    type: null,
    throughput: {
      en: '100 MiB/s',
      ru: '100 МиБ/сек.'
    },
    write: '120 IOPS',
    read: '320 IOPS'
  },
  {
    resource: 'volume_gigabytes_fast',
    group: 'ru-1a',
    name: {
      ru: 'Быстрый диск, 1 ГБ',
      en: 'Fast disk, 1 GB'
    },
    type: {
      en: 'SSD NVME',
      ru: 'SSD NVME'
    },
    throughput: {
      en: '500 MiB/s',
      ru: '500 МиБ/сек.'
    },
    write: '6400 IOPS',
    read: '12800 IOPS'
  },
  {
    resource: 'volume_gigabytes_fast',
    group: 'ru-1b',
    name: {
      ru: 'Быстрый диск, 1 ГБ',
      en: 'Fast disk, 1 GB'
    },
    type: null,
    throughput: {
      en: '500 MiB/s',
      ru: '500 МиБ/сек.'
    },
    write: '6400 IOPS',
    read: '12800 IOPS'
  },
  {
    resource: 'volume_gigabytes_fast',
    group: 'ru-1c',
    name: {
      ru: 'Быстрый диск, 1 ГБ',
      en: 'Fast disk, 1 GB'
    },
    type: null,
    throughput: {
      en: '500 MiB/s',
      ru: '500 МиБ/сек.'
    },
    write: '6400 IOPS',
    read: '12800 IOPS'
  },
  {
    resource: 'volume_gigabytes_fast',
    group: 'ru-2a',
    name: {
      ru: 'Быстрый диск, 1 ГБ',
      en: 'Fast disk, 1 GB'
    },
    type: null,
    throughput: {
      en: '500 MiB/s',
      ru: '500 МиБ/сек.'
    },
    write: '6400 IOPS',
    read: '12800 IOPS'
  },
  {
    resource: 'volume_gigabytes_fast',
    group: 'ru-2b',
    name: {
      ru: 'Быстрый диск, 1 ГБ',
      en: 'Fast disk, 1 GB'
    },
    type: null,
    throughput: {
      en: '500 MiB/s',
      ru: '500 МиБ/сек.'
    },
    write: '6400 IOPS',
    read: '12800 IOPS'
  },
  {
    resource: 'volume_gigabytes_fast',
    group: 'ru-2c',
    name: {
      ru: 'Быстрый диск, 1 ГБ',
      en: 'Fast disk, 1 GB'
    },
    type: null,
    throughput: {
      en: '500 MiB/s',
      ru: '500 МиБ/сек.'
    },
    write: '15000 IOPS',
    read: '25000 IOPS'
  },
  {
    resource: 'volume_gigabytes_fast',
    group: 'ru-3a',
    name: {
      ru: 'Быстрый диск, 1 ГБ',
      en: 'Fast disk, 1 GB'
    },
    type: null,
    throughput: {
      en: '500 MiB/s',
      ru: '500 МиБ/сек.'
    },
    write: '6400 IOPS',
    read: '12800 IOPS'
  },
  {
    resource: 'volume_gigabytes_fast',
    group: 'ru-3b',
    name: {
      ru: 'Быстрый диск, 1 ГБ',
      en: 'Fast disk, 1 GB'
    },
    type: null,
    throughput: {
      en: '500 MiB/s',
      ru: '500 МиБ/сек.'
    },
    write: '6400 IOPS',
    read: '12800 IOPS'
  },
  {
    resource: 'volume_gigabytes_fast',
    group: 'ru-7a',
    name: {
      ru: 'Быстрый диск, 1 ГБ',
      en: 'Fast disk, 1 GB'
    },
    type: null,
    throughput: {
      en: '500 MiB/s',
      ru: '500 МиБ/сек.'
    },
    write: '15000 IOPS',
    read: '25000 IOPS'
  },
  {
    resource: 'volume_gigabytes_fast',
    group: 'ru-8a',
    name: {
      ru: 'Быстрый диск, 1 ГБ',
      en: 'Fast disk, 1 GB'
    },
    type: null,
    throughput: {
      en: '500 MiB/s',
      ru: '500 МиБ/сек.'
    },
    write: '15000 IOPS',
    read: '25000 IOPS'
  },
  {
    resource: 'volume_gigabytes_fast',
    group: 'ru-9a',
    name: {
      ru: 'Быстрый диск, 1 ГБ',
      en: 'Fast disk, 1 GB'
    },
    type: null,
    throughput: {
      en: '500 MiB/s',
      ru: '500 МиБ/сек.'
    },
    write: '15000 IOPS',
    read: '25000 IOPS'
  },
  {
    resource: 'volume_gigabytes_iso',
    group: 'ru-1',
    name: {
      ru: '',
      en: ''
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'volume_gigabytes_iso',
    group: 'ru-2',
    name: {
      ru: '',
      en: ''
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'volume_gigabytes_iso',
    group: 'ru-7',
    name: {
      ru: '',
      en: ''
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'volume_gigabytes_iso',
    group: 'ru-8',
    name: {
      ru: '',
      en: ''
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'volume_gigabytes_iso',
    group: 'ru-9',
    name: {
      ru: '',
      en: ''
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'volume_gigabytes_local',
    group: 'ru-1a',
    name: {
      ru: 'Локальный диск, 1 ГБ',
      en: 'Local disk, 1 GB'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'volume_gigabytes_local',
    group: 'ru-1b',
    name: {
      ru: 'Локальный диск, 1 ГБ',
      en: 'Local disk, 1 GB'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'volume_gigabytes_local',
    group: 'ru-1c',
    name: {
      ru: 'Локальный диск, 1 ГБ',
      en: 'Local disk, 1 GB'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'volume_gigabytes_local',
    group: 'ru-2a',
    name: {
      ru: 'Локальный диск, 1 ГБ',
      en: 'Local disk, 1 GB'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'volume_gigabytes_local',
    group: 'ru-2b',
    name: {
      ru: 'Локальный диск, 1 ГБ',
      en: 'Local disk, 1 GB'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'volume_gigabytes_local',
    group: 'ru-2c',
    name: {
      ru: 'Локальный диск, 1 ГБ',
      en: 'Local disk, 1 GB'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'volume_gigabytes_local',
    group: 'ru-3a',
    name: {
      ru: 'Локальный диск, 1 ГБ',
      en: 'Local disk, 1 GB'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'volume_gigabytes_local',
    group: 'ru-3b',
    name: {
      ru: 'Локальный диск, 1 ГБ',
      en: 'Local disk, 1 GB'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'volume_gigabytes_local',
    group: 'ru-7a',
    name: {
      ru: 'Локальный диск, 1 ГБ',
      en: 'Local disk, 1 GB'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'volume_gigabytes_local',
    group: 'ru-8a',
    name: {
      ru: 'Локальный диск, 1 ГБ',
      en: 'Local disk, 1 GB'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'volume_gigabytes_local',
    group: 'ru-9a',
    name: {
      ru: 'Локальный диск, 1 ГБ',
      en: 'Local disk, 1 GB'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'volume_gigabytes_universal',
    group: 'ru-1a',
    name: {
      ru: 'Универсальный диск, 1 ГБ',
      en: 'Universal disk, 1 GB'
    },
    type: {
      en: 'SSD',
      ru: 'SSD'
    },
    throughput: {
      en: '150 MiB/s',
      ru: '150 МиБ/сек.'
    },
    write: '320 IOPS',
    read: '640 IOPS'
  },
  {
    resource: 'volume_gigabytes_universal',
    group: 'ru-1b',
    name: {
      ru: 'Универсальный диск, 1 ГБ',
      en: 'Universal disk, 1 GB'
    },
    type: null,
    throughput: {
      en: '150 MiB/s',
      ru: '150 МиБ/сек.'
    },
    write: '320 IOPS',
    read: '640 IOPS'
  },
  {
    resource: 'volume_gigabytes_universal',
    group: 'ru-1c',
    name: {
      ru: 'Универсальный диск, 1 ГБ',
      en: 'Universal disk, 1 GB'
    },
    type: null,
    throughput: {
      en: '150 MiB/s',
      ru: '150 МиБ/сек.'
    },
    write: '320 IOPS',
    read: '640 IOPS'
  },
  {
    resource: 'volume_gigabytes_universal',
    group: 'ru-2a',
    name: {
      ru: 'Универсальный диск, 1 ГБ',
      en: 'Universal disk, 1 GB'
    },
    type: null,
    throughput: {
      en: '150 MiB/s',
      ru: '150 МиБ/сек.'
    },
    write: '320 IOPS',
    read: '640 IOPS'
  },
  {
    resource: 'volume_gigabytes_universal',
    group: 'ru-2b',
    name: {
      ru: 'Универсальный диск, 1 ГБ',
      en: 'Universal disk, 1 GB'
    },
    type: null,
    throughput: {
      en: '150 MiB/s',
      ru: '150 МиБ/сек.'
    },
    write: '320 IOPS',
    read: '640 IOPS'
  },
  {
    resource: 'volume_gigabytes_universal',
    group: 'ru-2c',
    name: {
      ru: 'Универсальный диск, 1 ГБ',
      en: 'Universal disk, 1 GB'
    },
    type: null,
    throughput: {
      en: '200 MiB/s',
      ru: '200 МиБ/сек.'
    },
    write: '4000 IOPS',
    read: '7000 IOPS'
  },
  {
    resource: 'volume_gigabytes_universal',
    group: 'ru-3a',
    name: {
      ru: 'Универсальный диск, 1 ГБ',
      en: 'Universal disk, 1 GB'
    },
    type: null,
    throughput: {
      en: '150 MiB/s',
      ru: '150 МиБ/сек.'
    },
    write: '320 IOPS',
    read: '640 IOPS'
  },
  {
    resource: 'volume_gigabytes_universal',
    group: 'ru-3b',
    name: {
      ru: 'Универсальный диск, 1 ГБ',
      en: 'Universal disk, 1 GB'
    },
    type: null,
    throughput: {
      en: '150 MiB/s',
      ru: '150 МиБ/сек.'
    },
    write: '320 IOPS',
    read: '640 IOPS'
  },
  {
    resource: 'volume_gigabytes_universal',
    group: 'ru-7a',
    name: {
      ru: 'Универсальный диск, 1 ГБ',
      en: 'Universal disk, 1 GB'
    },
    type: null,
    throughput: {
      en: '200 MiB/s',
      ru: '200 МиБ/сек.'
    },
    write: '4000 IOPS',
    read: '7000 IOPS'
  },
  {
    resource: 'volume_gigabytes_universal',
    group: 'ru-8a',
    name: {
      ru: 'Универсальный диск, 1 ГБ',
      en: 'Universal disk, 1 GB'
    },
    type: null,
    throughput: {
      en: '200 MiB/s',
      ru: '200 МиБ/сек.'
    },
    write: '4000 IOPS',
    read: '7000 IOPS'
  },
  {
    resource: 'volume_gigabytes_universal',
    group: 'ru-9a',
    name: {
      ru: 'Универсальный диск, 1 ГБ',
      en: 'Universal disk, 1 GB'
    },
    type: null,
    throughput: {
      en: '200 MiB/s',
      ru: '200 МиБ/сек.'
    },
    write: '4000 IOPS',
    read: '7000 IOPS'
  },
  {
    resource: 'load_balancers_single_2_1024',
    group: 'ru-1',
    name: {
      ru: 'Балансировщик нагрузки &laquo;Базовый без резервирования&raquo;',
      en: 'Load Balancer &laquo;Basic without redundancy&raquo;'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'load_balancers_single_2_1024',
    group: 'ru-2',
    name: {
      ru: 'Балансировщик нагрузки &laquo;Базовый без резервирования&raquo;',
      en: 'Load Balancer &laquo;Basic without redundancy&raquo;'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'load_balancers_single_2_1024',
    group: 'ru-3',
    name: {
      ru: 'Балансировщик нагрузки &laquo;Базовый без резервирования&raquo;',
      en: 'Load Balancer &laquo;Basic without redundancy&raquo;'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'load_balancers_single_2_1024',
    group: 'ru-7',
    name: {
      ru: 'Балансировщик нагрузки &laquo;Базовый без резервирования&raquo;',
      en: 'Load Balancer &laquo;Basic without redundancy&raquo;'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'load_balancers_single_2_1024',
    group: 'ru-8',
    name: {
      ru: 'Балансировщик нагрузки &laquo;Базовый без резервирования&raquo;',
      en: 'Load Balancer &laquo;Basic without redundancy&raquo;'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'load_balancers_single_2_1024',
    group: 'ru-9',
    name: {
      ru: 'Балансировщик нагрузки &laquo;Базовый без резервирования&raquo;',
      en: 'Load Balancer &laquo;Basic without redundancy&raquo;'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'load_balancers_active_standby_2_1024',
    group: 'ru-1',
    name: {
      ru: 'Балансировщик нагрузки &laquo;Базовый с&nbsp;резервированием&raquo;',
      en: 'Load Balancer &laquo;Basic with redundancy&raquo;'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'load_balancers_active_standby_2_1024',
    group: 'ru-2',
    name: {
      ru: 'Балансировщик нагрузки &laquo;Базовый с&nbsp;резервированием&raquo;',
      en: 'Load Balancer &laquo;Basic with redundancy&raquo;'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'load_balancers_active_standby_2_1024',
    group: 'ru-3',
    name: {
      ru: 'Балансировщик нагрузки &laquo;Базовый с&nbsp;резервированием&raquo;',
      en: 'Load Balancer &laquo;Basic with redundancy&raquo;'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'load_balancers_active_standby_2_1024',
    group: 'ru-7',
    name: {
      ru: 'Балансировщик нагрузки &laquo;Базовый с&nbsp;резервированием&raquo;',
      en: 'Load Balancer &laquo;Basic with redundancy&raquo;'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'load_balancers_active_standby_2_1024',
    group: 'ru-8',
    name: {
      ru: 'Балансировщик нагрузки &laquo;Базовый с&nbsp;резервированием&raquo;',
      en: 'Load Balancer &laquo;Basic with redundancy&raquo;'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'load_balancers_active_standby_2_1024',
    group: 'ru-9',
    name: {
      ru: 'Балансировщик нагрузки &laquo;Базовый с&nbsp;резервированием&raquo;',
      en: 'Load Balancer &laquo;Basic with redundancy&raquo;'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'load_balancers_active_standby_4_2048',
    group: 'ru-1',
    name: {
      ru: 'Балансировщик нагрузки &laquo;Продвинутый с&nbsp;резервированием&raquo;',
      en: 'Load Balancer &laquo;Advanced with redundancy&raquo;'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'load_balancers_active_standby_4_2048',
    group: 'ru-2',
    name: {
      ru: 'Балансировщик нагрузки &laquo;Продвинутый с&nbsp;резервированием&raquo;',
      en: 'Load Balancer &laquo;Advanced with redundancy&raquo;'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'load_balancers_active_standby_4_2048',
    group: 'ru-3',
    name: {
      ru: 'Балансировщик нагрузки &laquo;Продвинутый с&nbsp;резервированием&raquo;',
      en: 'Load Balancer &laquo;Advanced with redundancy&raquo;'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'load_balancers_active_standby_4_2048',
    group: 'ru-7',
    name: {
      ru: 'Балансировщик нагрузки &laquo;Продвинутый с&nbsp;резервированием&raquo;',
      en: 'Load Balancer &laquo;Advanced with redundancy&raquo;'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'load_balancers_active_standby_4_2048',
    group: 'ru-8',
    name: {
      ru: 'Балансировщик нагрузки &laquo;Продвинутый с&nbsp;резервированием&raquo;',
      en: 'Load Balancer &laquo;Advanced with redundancy&raquo;'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  },
  {
    resource: 'load_balancers_active_standby_4_2048',
    group: 'ru-9',
    name: {
      ru: 'Балансировщик нагрузки &laquo;Продвинутый с&nbsp;резервированием&raquo;',
      en: 'Load Balancer &laquo;Advanced with redundancy&raquo;'
    },
    type: null,
    throughput: null,
    read: null,
    write: null
  }
]